const Settings = {
    env: "prod",
    webUrl: "https://hecafe.com.tw",
    apiUrl: "https://prod.hecafe-api.com",
    mediaHost: "https://dvkvars7ubgms.cloudfront.net",
    s3Host: "https://s3-ap-northeast-1.amazonaws.com/hecafe.com.tw",
    debug: false,
    SERVICE_AUTH: {
      host: "https://auth.revtel-api.com/v1",
      clientId: "mr9zb58vba",
      identityApi: "https://sls.hecafe-api.com/identity"
    },
    facebookAppId: "",
    facebookPixelId: "307359327631479",
    googleClientId: "115128487422-bs5m8q90u3g4ata8lb9ujorusgpqhefj.apps.googleusercontent.com",
    googleAnalyticsId: "UA-127064537-3",
    googleRecaptchaSiteKey: "6LfVVq0UAAAAACa4Ir2VOBZRtWwDvvsaVfkl1-f3",
    userType: "aws",
    slsApi: {
      host: "https://di61fw9voc.execute-api.ap-northeast-1.amazonaws.com/prod",
      host2:  "https://sls.hecafe-api.com"
    },
    aws: {
      tableUser: "hecafe.com.tw.user",
      tableOrder: "hecafe.com.tw.order",
      tableStoreOrder: "hecafe.com.tw.store-order"
    },
};

module.exports = Settings;

